import { DWARF_RIG_VERSION, dwarfProportions, dwarfStandardHeight, morphDwarfProportions } from '../../../content/characters/rigs/dwarf.js';
import type { UnitDefinition } from '../../../shared/game/world-types.js';
import { createHumanoidModel, type HumanModelOptions } from './human-model.js';

/** A stout morph and Dwarf head changes on the shared humanoid skeleton and equipment assembly. */
export function createDwarfModel(definition: UnitDefinition, options?: HumanModelOptions) {
  const look = definition.appearance;
  if (!look || look.ancestry !== 'dwarf') throw new Error('The Dwarf model requires Dwarf appearance content.');
  const p = morphDwarfProportions(dwarfProportions(look.rig), look.parts?.face);
  const rig = createHumanoidModel({ ...definition, appearance: { ...look, height: look.height ?? dwarfStandardHeight(p.id) } }, p, options, { face: p.face });
  rig.root.userData.nimblezRigVersion = DWARF_RIG_VERSION;
  return rig;
}
